module.exports = __webpack_public_path__ + "img/karakters-27.7958776a.jpg";